module.exports = __webpack_public_path__ + "img/qyjy2-1.77846af7.png";